/**
 * For some urls we dont require auth-token in header (Eg => signed urls of Azure)
 * Hence put those urls(Domain , endpoint !important must be unique)
 */
const forbiddenUrls = ['blob.core.windows.net', 'https://checkip.amazonaws.com/']

/**
 *
 * @param requestUrl the request url going through token-retrieval interceptor
 * @returns if the req url should insert the auth token or not
 */
export function forbidAuthenticationInsertion(requestUrl: string) {
  for (let i = 0; i < forbiddenUrls.length; i++) {
    if (requestUrl.includes(forbiddenUrls[i])) return true
  }
  return false
}
